import { useEffect, useRef } from "react";

// Full-viewport dotted grid that reacts to mouse position via CSS variables.
export function GridBackground() {
  const ref = useRef(null);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    let tx = 50, ty = 50;
    const onMove = (e) => {
      tx = (e.clientX / window.innerWidth) * 100;
      ty = (e.clientY / window.innerHeight) * 100;
      el.style.setProperty("--mx", `${tx}%`);
      el.style.setProperty("--my", `${ty}%`);
    };
    window.addEventListener("mousemove", onMove, { passive: true });
    return () => window.removeEventListener("mousemove", onMove);
  }, []);
  return (
    <div
      ref={ref}
      className="fixed inset-0 tech-dots pointer-events-none opacity-70 z-0"
      aria-hidden="true"
    />
  );
}
